var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDangerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10,
    r: 10,
    fill: "#ED4A4A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4706 5.70482C11.406 5.57876 11.3079 5.47297 11.187 5.39909C11.0662 5.32522 10.9273 5.28613 10.7856 5.28613C10.644 5.28613 10.5051 5.32522 10.3843 5.39909C10.2634 5.47297 10.1653 5.57876 10.1007 5.70482L5.86797 14.1702C5.80894 14.2874 5.78083 14.4177 5.78632 14.5488C5.79181 14.6798 5.83072 14.8073 5.89934 14.9191C5.96797 15.0309 6.06404 15.1233 6.17842 15.1876C6.29281 15.2518 6.42172 15.2857 6.5529 15.2861H15.0184C15.1496 15.2857 15.2785 15.2518 15.3929 15.1876C15.5073 15.1233 15.6033 15.0309 15.6719 14.9191C15.7406 14.8073 15.7795 14.6798 15.785 14.5488C15.7905 14.4177 15.7624 14.2874 15.7033 14.1702L11.4706 5.70482Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9644 8.85754V11.179",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9642 13.1433C10.8656 13.1433 10.7856 13.0633 10.7856 12.9647C10.7856 12.8661 10.8656 12.7861 10.9642 12.7861",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9644 13.1433C11.063 13.1433 11.1429 13.0633 11.1429 12.9647C11.1429 12.8661 11.063 12.7861 10.9644 12.7861",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDangerIcon);
export default __webpack_public_path__ + "static/media/DangerIcon.8dc15a8f7238e225bbd3d139be7aaa2c.svg";
export { ForwardRef as ReactComponent };